import { flags } from '../constant';

// === dev/prod ===

// @ts-ignore
export const isProd = process.env.NODE_ENV === 'production';

const testEnv = () => {
  const userAgent = navigator?.userAgent ?? '';

  // === 设备 ===
  const isiOS = /iPhone|iPad|iPod/i.test(userAgent);
  const isAndroid = /Android/i.test(userAgent);
  const devices: { [k: number]: string } = {
    0b00: 'pc',
    0b01: 'ios',
    0b10: 'android',
  };
  const device = devices[Number(isiOS) + (Number(isAndroid) << 1)];

  // === 双平台 ===
  const isQQ = / QQ/i.test(userAgent);
  const isWechat = /MicroMessenger/i.test(userAgent);
  const platforms: { [k: number]: string } = {
    0b01: 'qq',
    0b10: 'wechat',
    // TODO: 王者、和平营地 msdk->source=yindi
  };
  const platform = platforms[Number(isQQ) + (Number(isWechat) << 1)];

  // === SDK ===
  const isMSDK = /msdk/i.test(userAgent);
  const isSlugSDK = /tiem ingame browser/i.test(userAgent);
  const sdks: { [k: number]: string } = {
    0b01: 'msdk',
    0b10: 'slugsdk',
  };
  const sdk = sdks[Number(isMSDK) + (Number(isSlugSDK) << 1)];

  return {
    isiOS, isIOS: isiOS,
    isAndroid,

    isQQ,
    isWechat,

    isMSDK,
    isSlugSDK,

    env: {
      device,
      platform,
      sdk,
    },
  };
};

export type ENV = ReturnType<typeof testEnv>

export const getEnv = () => {
  if (!flags.env) {
    flags.env = testEnv();
  }
  return flags.env;
};

export const isMSDKV3 = ({ search, hash }: Location) => /msdkEncodeParam/.test(search) || /msdkEncodeParam/.test(hash);

export const isMSDKV5 = ({ search, hash }: Location) => /itopencodeparam/.test(search) || /itopencodeparam/.test(hash);
